import * as React from "react";
import Header from "./Header";
import {makeStyles} from "@fluentui/react-components";
import {useEffect, useState} from "react";
import Tabs from "./tabs/Tabs";
import Connexion from "./Connexion";
import Footer from "./Footer";
import {DocumentModel} from "../../utils/models/document.model";

interface AppProps {
    title: string;
    fileName: string;
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        minWidth: 0,
        minHeight: 0,
        overflow: "hidden",
    },
    center: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: "auto",
        minHeight: 0,
        minWidth: 0,
        width: "100%",
        maxWidth: "100%",
        overflowX: "hidden",
        overflowY: "auto",
        boxSizing: "border-box",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "12px",
        paddingRight: "12px",
    },
});

const App = (props: AppProps) => {
    const styles = useStyles();

    const imageUrl = "https://client.zlawyer.fr/assets/images/logo/zlogo.png";

    const [modeMaintenance, setModeMaintenance] = React.useState(false);

    const [estConnecte, setEstConnecte] = React.useState(false);
    const [data, setData] = useState(new DocumentModel());

    useEffect(() => {
        setEstConnecte(!!localStorage.getItem("zLawyerToken"));

        const zLawyerToken = window.localStorage.getItem("zLawyerToken");

        fetch(`https://zlawyerapi.azurewebsites.net/parametres/status-complement-word`)
            .then((response) => {
                if (!response.ok) {
                    return {'succes': false};
                }
                return response.json();
            })
            .then((data) => {
                setModeMaintenance(data['succes'] === false);
            }).catch(() => {
        });

        if (!zLawyerToken || !props.fileName) {
            return;
        }

        fetch(`https://zlawyerapi.azurewebsites.net/api/v2/documents/infos?nom=${encodeURIComponent(props.fileName)}`, {
            headers: {
                Authorization: `Bearer ${zLawyerToken}`,
            },
        })
            .then((response) => {
                if (!response.ok) {
                    return null;
                }
                return response.json();
            })
            .then((infos) => {
                if (!infos) {
                    return;
                }
                const document = typeof infos === "string" ? JSON.parse(infos) : infos;
                setData({
                    ...document,
                    Type: document.Type ?? document.type,
                    Nom: document.Nom ?? document.nom,
                    ModeleId: document.ModeleId ?? document.modeleId,
                    DriveId: document.DriveId ?? document.driveId,
                    DossierId: document.DossierId ?? document.dossierId,
                    NomDossier: document.NomDossier ?? document.nomDossier,
                });
            });
    }, [props.fileName]);

    return (
        <div className={styles.root}>
            <Header logo={imageUrl} title={props.title} document={data}/>
            {!modeMaintenance && <div className={styles.center}>
                {estConnecte ? <Tabs document={data}/> : <Connexion/>}
            </div>}
            {modeMaintenance && <div className={styles.center}>
                <div style={{ width: "100%", maxWidth: "100%", textAlign: "center", overflowWrap: "anywhere" }}>
                    <h3 className="mt-2 text-sm font-semibold text-gray-900">Complément en maintenance</h3>
                    <p className="my-4 text-sm text-gray-500">
                        Le complément zLawyer est actuellement en maintenance. Veuillez réessayer ultérieurement.
                    </p>
                </div>
            </div>}
            <Footer/>
        </div>
    );
};

export default App;
